module.exports = __webpack_public_path__ + "static/media/winter coordinator.bb2cc8b1.jpg";